/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Page_Download_DescInputs */

const en_pc_page_download_desc = /** @type {(inputs: Pc_Page_Download_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the latest PhotoCraft ArtCraft release for macOS, Windows, Linux, FreeBSD or the web. Direct links to the official ArtCraft open source releases on GitHub.`)
};

const zh_pc_page_download_desc = /** @type {(inputs: Pc_Page_Download_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载最新版 PhotoCraft ArtCraft，支持 macOS、Windows、Linux、FreeBSD 和网页版。直接链接 GitHub 上的 ArtCraft 官方开源发布。`)
};

/**
* | output |
* | --- |
* | "Download the latest PhotoCraft ArtCraft release for macOS, Windows, Linux, FreeBSD or the web. Direct links to the official ArtCraft open source releases on ..." |
*
* @param {Pc_Page_Download_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_page_download_desc = /** @type {((inputs?: Pc_Page_Download_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Page_Download_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_page_download_desc(inputs)
	return zh_pc_page_download_desc(inputs)
});
export { pc_page_download_desc as "pc.page.download.desc" }